import { render } from "./ProfileEditComplete.vue?vue&type=template&id=84fc1468&scoped=true"
import script from "./ProfileEditComplete.vue?vue&type=script&lang=js"
export * from "./ProfileEditComplete.vue?vue&type=script&lang=js"

import "./ProfileEditComplete.vue?vue&type=style&index=0&id=84fc1468&lang=scss&scoped=true"

import exportComponent from "/var/www/html/app_player/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84fc1468"]])

export default __exports__